import { render, staticRenderFns } from "./gj-base-table.vue?vue&type=template&id=646752c6&scoped=true&"
import script from "./gj-base-table.vue?vue&type=script&lang=js&"
export * from "./gj-base-table.vue?vue&type=script&lang=js&"
import style0 from "./gj-base-table.vue?vue&type=style&index=0&id=646752c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646752c6",
  null
  
)

export default component.exports